import { apiGet } from './utils';

export interface SubscriptionPayment {
  key: string;
  uuid: string;
  date_created: string | null;
  tasks_expire: string | null;
  tasks_included: number;
  tasks_used: number;
  rollover: number;
  product_id: string | null;
  amount: string | null;
  numeric_amount: number | null;
  gift: boolean;
  success: boolean;
  refunded: boolean;
  stripe_invoice_id: string | null;
  stripe_subscription_id: string | null;
  minutes_included: number;
}

export interface SubscriptionPaymentResponse {
  items: SubscriptionPayment[];
  paged: string;
  cursor: string | null;
  has_more: boolean;
}

export const subscriptionPaymentApi = {
  /**
   * List the current user's subscription payments
   */
  async list(cursor?: string): Promise<SubscriptionPaymentResponse> {
    return apiGet<SubscriptionPaymentResponse>('/payment/list', { cursor });
  },

  /**
   * List subscription payments for any user (manager only)
   */
  async managerList(
    userUuid: string,
    cursor?: string
  ): Promise<SubscriptionPaymentResponse> {
    return apiGet<SubscriptionPaymentResponse>('/payment/manager-list', {
      user_uuid: userUuid,
      cursor,
    });
  },
};
